import {MessagesBadge} from '@/components/_domain/SidebarItemBadges/MessagesBadge/MessagesBadge';
import {SidebarItem} from '@/contexts/SidebarContext/SidebarContext';
import {
  AssessmentRounded,
  Assignment,
  CelebrationRounded,
  Chat,
  Description,
  EventRounded,
  MonitorHeart,
  Newspaper,
  Payments,
  PinDrop,
  ShoppingCartRounded,
  Storefront,
} from '@mui/icons-material';

export const newsFeedItem: SidebarItem = {
  url: '/updates',
  label: 'Newsfeed',
  icon: <Newspaper fontSize="small" />,
};

export const messagesItem: SidebarItem = {
  url: '/messages',
  label: 'Messages',
  icon: <Chat fontSize="small" />,
  BadgeComponent: MessagesBadge,
};

export const surveysItem: SidebarItem = {
  url: '/surveys',
  label: 'Surveys',
  icon: <AssessmentRounded fontSize="small" />,
};

export const documentsItem: SidebarItem = {
  url: '/documents',
  label: 'Documents',
  icon: <Description fontSize="small" />,
};

export const eventsItem: SidebarItem = {
  url: '/events',
  label: 'Events',
  icon: <CelebrationRounded fontSize="small" />,
};

export const facilitiesItem: SidebarItem = {
  url: '/facilities',
  label: 'Facilities',
  icon: <PinDrop fontSize="small" />,
};

export const marketplaceItem: SidebarItem = {
  url: '/marketplace',
  label: 'Marketplace',
  icon: <Storefront fontSize="small" />,
};

export const productsItem: SidebarItem = {
  url: '/community-products',
  label: 'Products',
  icon: <ShoppingCartRounded fontSize="small" />,
};

export const paymentsItem: SidebarItem = {
  url: '/payments',
  label: 'Account',
  icon: <Payments fontSize="small" />,
};

export const formsItem: SidebarItem = {
  url: '/forms',
  label: 'Forms',
  icon: <Assignment fontSize="small" />,
};

export const appointmentsItem: SidebarItem = {
  url: '/appointments',
  label: 'Appointments',
  icon: <EventRounded fontSize="small" />,
};

export const pulseItem: SidebarItem = {
  url: '/pulse',
  label: 'Pulse',
  icon: <MonitorHeart fontSize="small" />,
};

export const dividerItem: SidebarItem = {
  url: '',
  label: '',
  icon: null,
  type: 'divider',
};
